export const SUB_MODULES_LIST = "SUB_MODULES_LIST";
export const SUB_MODULES_PAGINATION = "SUB_MODULES_PAGINATION";

export const SUB_MODULE_INSERT = "SUB_MODULE_INSERT";
export const SUB_MODULE_UPDATE = "SUB_MODULE_UPDATE";
export const SUB_MODULE_DELETE = "SUB_MODULE_DELETE";